import { createUniqueKey, logErrorToHasura } from "_shared/request";
import { JwtToken, user } from "_shared/auth";
import { getEnv } from "../../../../utils/constants";
import axios from "axios";
import { z } from "zod";

const instance = axios.create({
  baseURL: getEnv("BASEURL"),
});

const azureADpostServiceNow = async (props) => {
  try {
    const response = instance({
      method: "post",
      ...props,
      params: {
        ...props.params,
      },
      headers: {
        ...props.headers,
        "Content-Type": "application/json",
        Accept: "*/*",
        Authorization: `Bearer ${JwtToken}`,
      },
    });
    return response;
  } catch (error) {
    if (process.env.NODE_ENV === "production") {
      const errorDetails = {
        teamId: user.teamId || 0,
        message: error.message || "No error message.",
        stack: error.stack || "No error details provided.",
        httpRequest: {
          method: "POST",
          url: props.url,
          params: props.params || "No params provided.",
          headers: props.headers || "No headers provided.",
          data: props.data || "No data provided.",
        },
        httpResponse: {
          status:
            error.response?.status || "Server did not respond to the request.",
          statusText:
            error.response?.statusText ||
            "Server did not respond to the request.",
          data:
            error.response?.data || "Server did not respond to the request.",
        },
      };

      if (axios.isAxiosError(error)) {
        errorDetails.type = "HTTP";
      } else {
        errorDetails.type = "MISC";
      }
      logErrorToHasura(errorDetails, createUniqueKey(props));
    }
    console.error("request post error:", error);
    throw error;
  }
};

const azureADgetServiceNow = async (props, schema) => {
  try {
    const response = await instance({
      method: "get",
      ...props,
      params: {
        ...props.params,
      },
      headers: {
        ...props.headers,
        "Content-Type": "application/json",
        Accept: "*/*",
        Authorization: `Bearer ${JwtToken}`,
      },
    });
    if (schema) {
      const validatedData = schema.parse(response.data);
      response.data = validatedData;
      return response;
    } else {
      return response;
    }
  } catch (error) {
    if (process.env.NODE_ENV === "production") {
      const errorDetails = {
        teamId: user.teamId || 0,
        message: error.message || "No error message.",
        stack: error.stack || "No error details provided.",
        httpRequest: {
          method: "GET",
          url: props.url,
          params: props.params || "No params provided.",
          headers: props.headers || "No headers provided.",
        },
        httpResponse: {
          status:
            error.response?.status || "Server did not respond to the request.",
          statusText:
            error.response?.statusText ||
            "Server did not respond to the request.",
          data:
            error.response?.data || "Server did not respond to the request.",
        },
      };

      if (axios.isAxiosError(error)) {
        errorDetails.type = "HTTP";
      } else if (error instanceof z.ZodError) {
        errorDetails.type = "VALIDATION";
        errorDetails.stack = error.issues;
      } else {
        errorDetails.type = "MISC";
      }
      logErrorToHasura(errorDetails, createUniqueKey(props));
    }
    console.error("azureADgetServiceNow request get error:", error);
    throw error;
  }
};

export const getApprovals = ({ params }) => {
  return azureADgetServiceNow({
    url: `${getEnv("BASEURL")}/forward/servicenow/getapprovals`,
    params,
  });
};

export const getApprovalDetails = ({ params }) => {
  return azureADgetServiceNow({
    url: `${getEnv("BASEURL")}/forward/servicenow/getrequestinfo`,
    params,
  });
};

export const getRequests = ({ params }) => {
  return azureADgetServiceNow({
    url: `${getEnv("BASEURL")}/forward/servicenow/getrequests`,
    params,
  });
};

export const postApprovalAction = (data) => {
  const { approvalSysID, approvalTeamID, action, comments } = data;

  return azureADpostServiceNow({
    url: `${getEnv("BASEURL")}/forward/servicenow/approvalAction`,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },

    data: JSON.stringify({
      approval_sys_id: approvalSysID,
      approver_tm_id: approvalTeamID,
      action,
      comments,
    }),
  });
};
